import { Component, ElementRef, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import { PlatformLocation } from '@angular/common'
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/service/auth.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  itemFilter = {};
  showPage = 'vendas';
  menuSelect = 'gestao-loja';
  loadingToggle = false;
  displayShowBack: boolean = false;
  showMenu = false;
  routerMoment!: any;
  errorBoards: any = [];


  constructor(private api: ApiService, private router: Router, private location: PlatformLocation, private autService: AuthService, private el: ElementRef) {
    this.routerMoment = this.router;
    //redirect on back button.
    location.onPopState(() => {
      if (this.routerMoment === '/home/sale') {
        this.showPage = 'vendas';
        this.showMenu = true;
      } else if (this.routerMoment === '/home/financial') {
        this.showPage = 'financeiro';
        this.showMenu = false;
      } else if (this.routerMoment === '/home/manufacturing') {
        this.showPage = 'industrial';
        this.showMenu = false;
      } else if (this.routerMoment === '/home/salers') {
        this.showPage = 'vendedores';
        this.showMenu = false;
      }  else {
        this.showPage = 'vendas';
        this.showMenu = true;
      }
    });
  }

  ngOnInit() {
    this.api.setHeader();
    if (this.location.pathname === '/home/sale') {
      this.showPage = 'vendas';
      this.showMenu = true;
      let splitOperations: any = [];
      try {
        this.setOperations().subscribe(data => {
          if (data.items[0].value) {
            splitOperations = data.items[0].value.split(';').map(Number);
            localStorage.setItem('operations', JSON.stringify(splitOperations));
          } else {
            localStorage.setItem('operations', '');
          }
        });
      } catch (error : unknown) {
        localStorage.setItem('operations', '');
      }
    } else if (this.location.pathname === '/home/financial') {
      this.showPage = 'financeiro';
      this.showMenu = false;
    } else if (this.location.pathname === '/home/manufacturing') {
      this.showPage = 'industrial'
      this.showMenu = false;
    } else if (this.location.pathname === '/home/salers') {
      this.showPage = 'vendedores';
      this.showMenu = false;
      let splitOperations: any = [];
      try {
        this.setOperations().subscribe(data => {
          if (data.items[0].value) {
            splitOperations = data.items[0].value.split(';').map(Number);
            localStorage.setItem('operations', JSON.stringify(splitOperations));
          } else {
            localStorage.setItem('operations', '');
          }
        });
      } catch (error : unknown) {
        localStorage.setItem('operations', '');
      }
    } else {
      this.showPage = 'vendas';
      this.showMenu = true;
    }

    this.getCurrentSellerAuthorization()
  }


  getCurrentPathname(): string {
    return this.router.url;
  }

  toggleFilterAuthorization(){
    const raw = localStorage.getItem('sellerCode');
    return raw ? JSON.parse(raw) : null;
  }

  getCurrentSellerAuthorization () {
    const pathname = this.getCurrentPathname();
    this.displayShowBack =  pathname === '/home/salers' &&  this.toggleFilterAuthorization() ? true:false
  }


  setOperations(): Observable<any> {
    return this.api.getParam('DS_LST_OPER_MOPFC001');
  }

  changeMenuSelect(item: any) {
    let filterDontVisible = this.el.nativeElement.querySelector('.select');
    let filterVisible = this.el.nativeElement.querySelector('.dont-select');
    if (filterVisible) {
      filterVisible.classList.add('select');
      filterVisible.classList.remove('dont-select');
    }
    if (filterDontVisible) {
      filterDontVisible.classList.add('dont-select');
      filterDontVisible.classList.remove('select');
    }
    this.menuSelect = item;
  }

  changeTypePage(item: any) {
    this.showPage = item;
    item === 'vendas' ? this.showMenu = true : this.showMenu = false
    this.loadingControll();
  }

  filterChange(item: any) {
    this.itemFilter = item
    this.filterValue();
  }

  logStatusChange() {
    this.errorBoards = [];
  }

  errorEmitter(item: any) {
    this.errorBoards.push(item);
  }

  filterValue() {
    return this.itemFilter;
  }

  handleShowBack (){
    this.location.back();
  }

  loadingControll() {
    setTimeout(() => {
      this.loadingToggle = true;
    }, 3000);
  }
}
